import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { Profile } from '../../types';

// Link de indicação (parceiro/vendedor_parceiro) — gera o código sob demanda se
// ainda não existir, e expõe os handlers de copiar/compartilhar.
export function useCodigoIndicacao(profile: Profile | null | undefined, enabled: boolean, refreshProfile: () => Promise<void>) {
    const [gerandoCodigo, setGerandoCodigo] = useState(false);
    const [linkCopiado, setLinkCopiado] = useState(false);

    useEffect(() => {
        if (!enabled || !profile || profile.codigo_indicacao || gerandoCodigo) return;
        let cancelled = false;
        const gerarCodigo = async () => {
            setGerandoCodigo(true);
            const letras = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
            const alnum = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
            const randomFrom = (chars: string, len: number) =>
                Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
            for (let tentativa = 0; tentativa < 5; tentativa++) {
                const codigo = `${randomFrom(letras, 2)}-${randomFrom(alnum, 6)}`;
                const { error } = await supabase.from('profiles').update({ codigo_indicacao: codigo }).eq('id', profile.id);
                if (!error) {
                    if (!cancelled) await refreshProfile();
                    break;
                }
                if (error.code !== '23505') break; // erro diferente de colisão de unique — não adianta tentar de novo
            }
            if (!cancelled) setGerandoCodigo(false);
        };
        gerarCodigo();
        return () => { cancelled = true; };
    }, [enabled, profile?.id, profile?.codigo_indicacao]);

    const linkIndicacao = profile?.codigo_indicacao
        ? `${window.location.origin}${window.location.pathname}#/cadastro-consultor/${profile.codigo_indicacao}`
        : '';

    const handleCopiarLink = async () => {
        if (!linkIndicacao) return;
        await navigator.clipboard.writeText(linkIndicacao);
        setLinkCopiado(true);
        setTimeout(() => setLinkCopiado(false), 2000);
    };

    const handleCompartilharWhatsapp = () => {
        if (!linkIndicacao) return;
        const texto = `Vem vender energia com a gente! Cadastre-se pelo meu link: ${linkIndicacao}`;
        window.open(`https://wa.me/?text=${encodeURIComponent(texto)}`, '_blank');
    };

    return { gerandoCodigo, linkCopiado, linkIndicacao, handleCopiarLink, handleCompartilharWhatsapp };
}